import * as Cesium from 'cesium';
import { useCallback } from 'react';
import { isPointInPolygon } from '../../utils/geometryUtils';
export const usePickTerrainPosition = (viewer) => {
    return useCallback((screenPosition) => {
        if (!viewer || viewer.isDestroyed())
            return null;
        const ray = viewer.camera.getPickRay(screenPosition);
        if (!ray)
            return null;
        const position = viewer.scene.globe.pick(ray, viewer.scene);
        if (position)
            return position;
        return viewer.camera.pickEllipsoid(screenPosition, viewer.scene.globe.ellipsoid) || null;
    }, [viewer]);
};
export const useConstraintCheck = (constraintPolygon) => {
    return useCallback((position) => {
        if (!constraintPolygon || constraintPolygon.length < 3)
            return true;
        const cartographic = Cesium.Cartographic.fromCartesian(position);
        const clickPoint = {
            lat: Cesium.Math.toDegrees(cartographic.latitude),
            lng: Cesium.Math.toDegrees(cartographic.longitude)
        };
        return isPointInPolygon(clickPoint, constraintPolygon);
    }, [constraintPolygon]);
};
